import type { ZuubPayer } from '@/@types/zuub/contracts';

import { getPayerColorCombo } from '../helpers';
import { getFirstTwoLetters } from '../utils/payerUtils';

interface PayerAvatarProps {
  payer: ZuubPayer | undefined;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'vai-w-[40px] vai-h-[40px] vai-text-lg',
  md: 'vai-w-[50px] vai-h-[50px] vai-text-2xl',
  lg: 'vai-w-[60px] vai-h-[60px] vai-text-3xl',
};

export const PayerAvatar = ({ payer, size = 'md' }: PayerAvatarProps) => {
  const payerName = payer?.name || 'Unknown Payer';
  const colorCombo = getPayerColorCombo(payerName);
  const firstTwoLetters = getFirstTwoLetters(payerName);

  return (
    <div
      className={`${sizeClasses[size]} vai-rounded-lg vai-flex vai-items-center vai-justify-center vai-font-bold`}
      style={{
        backgroundColor: colorCombo.backgroundColor,
        color: colorCombo.color,
      }}
    >
      {firstTwoLetters}
    </div>
  );
};
